// Initialize Cocoon for nested forms
document.addEventListener("turbolinks:load", function() {
  console.log("Initializing Cocoon event handlers");
  
  // Re-initialize select2 on newly added nested form elements
  $(document).on('cocoon:after-insert', function(e, insertedItem) {
    console.log("Cocoon after insert event detected");
    $(insertedItem).find('select').select2({
      width: '100%'
    });
  });

  // Add debug logging for Cocoon events
  $(document).on('cocoon:before-insert', function() {
    console.log("Cocoon before insert event detected");
  });

  $(document).on('cocoon:after-remove', function() {
    console.log("Cocoon after remove event detected");
  });
}); 